<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    @if (!assessment?.id) {
      <h3 class="text-end text-secondary pb-2">Création d'un diagnostic</h3>
    }
    @if (assessment?.id) {
      <h3 class="text-end text-secondary pb-2">Diagnostic du {{ assessment.creationDateInterview | date }}</h3>
    }
  </div>

  @if (assessment && assessmentForm) {
    <form [formGroup]="assessmentForm">
      <div class="modal-body">
        <!-- ********************************************************************************************* -->
        <!-- * HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADE * -->
        <!-- * HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADE * -->
        <!-- ********************************************************************************************* -->
        <div class="row">
          <!-- Interview date  -->
          <div class="mb-3 col-12 col-lg-4">
            <label class="required">Date d'entretien</label>
            <app-datepicker id="fieldCreationDateInterview" formControlName="creationDateInterview" [invalid]="submitted && fcAss.creationDateInterview.invalid"> </app-datepicker>
            @if (submitted && fcAss?.creationDateInterview?.errors?.required) {
              <small class="form-text text-danger"> La date est requise. </small>
            }
            @if (fcAss?.creationDateInterview?.errors?.dateFormat) {
              <small class="form-text text-danger"> La date est invalide. </small>
            }
          </div>
          <!-- Status -->
          <div class="mb-3 col-12 col-lg-4">
            <label class="text-secondary required">Statut</label>
            <select class="form-select" formControlName="status" (change)="onStatusChange()" [class.is-invalid]="submitted && fcAss.status.invalid">
              @for (status of statusMap | keyvalue: stringAscOrder; track status) {
                <option [ngValue]="status.key">
                  {{ status.value }}
                </option>
              }
            </select>
            @if (submitted && fcAss?.status?.errors?.required) {
              <small class="form-text text-danger"> Le statut est requis. </small>
            }
          </div>
          <!-- Status update date -->
          <div class="mb-3 col-12 col-lg-4">
            <label class="text-secondary">Date MAJ statut diagnostic</label>
            <app-datepicker id="fieldUpdateStatusDate" formControlName="updateStatusDate"></app-datepicker>
          </div>
          <!-- Context -->
          <div class="mb-3 col-12 col-lg-8">
            <label class="text-secondary required">Contexte de l'entretien</label>
            <select class="form-select" formControlName="context" [class.is-invalid]="submitted && fcAss.context.invalid">
              @for (context of contextMap | keyvalue: assessmentContextSort; track context) {
                <option [ngValue]="context.key">
                  {{ context.value }}
                </option>
              }
            </select>
            @if (submitted && fcAss?.context?.errors?.required) {
              <small class="form-text text-danger"> Le contexte est requis. </small>
            }
          </div>
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL * -->
        <!-- * DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL * -->
        <!-- ********************************************************************************************* -->
        <div #detailAccordion class="card border-1 card-border-radius-0" formGroupName="detailForm">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button">Votre situation personnelle</button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <p><strong>État civil</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <!-- ********************************************************************************************* -->
                          <!-- Checked beneficiary personal data -->
                          <div class="mb-3 text-secondary col-12">
                            <div class="form-check">
                              <input id="checked-benef-personal-data" type="checkbox" class="form-check-input" formControlName="checkedBenefPersonalData" />
                              <label class="custom-control-label required" for="checked-benef-personal-data"> J'ai vérifé que l'état civil, l'adresse, les contacts et la situation familiale du bénéfciaire sont à jour. </label>
                            </div>
                            @if (submitted && fcDet?.checkedBenefPersonalData?.errors?.required) {
                              <small class="form-text text-danger"> La confirmation est obligatoire </small>
                            }
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Valid identity documents -->
                        <div class="row mt-4">
                          <label>Pièce d’identité en cours de validité (CNI, passeport ou titre de séjour) ?</label>
                          <div class="col-4 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="validIdentityDocumentYes" type="radio" class="form-check-input" formControlName="validIdentityDocument" [value]="true" />
                              <label for="validIdentityDocumentYes" class="form-check-label">Oui</label>
                            </div>
                          </div>
                          <div class="col-4 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="validIdentityDocumentNo" type="radio" class="form-check-input" formControlName="validIdentityDocument" [value]="false" />
                              <label for="validIdentityDocumentNo" class="form-check-label">Non</label>
                            </div>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Renewal in progress -->
                        @if (fvDet.validIdentityDocument === false) {
                          <div class="row mt-2">
                            <div class="col-8 col-lg-8">
                              <label>Renouvellement en cours ?</label>
                            </div>
                            <div class="col-2 col-lg-2">
                              <div class="form-check form-check-inline">
                                <input id="renewalInProgressYes" type="radio" class="form-check-input" formControlName="renewalInProgress" [value]="true" />
                                <label for="renewalInProgressYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-2 col-lg-2">
                              <div class="form-check form-check-inline">
                                <input id="renewalInProgressNo" type="radio" class="form-check-input" formControlName="renewalInProgress" [value]="false" />
                                <label for="renewalInProgressNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        }
                        <!-- ********************************************************************************************* -->
                        <!-- Renewal help needed -->
                        @if (fvDet.validIdentityDocument === false) {
                          <div class="row mt-2">
                            <div class="col-8 col-lg-8">
                              <label>Si oui, besoin d'aide dans cette démarche ?</label>
                            </div>
                            <div class="col-2 col-lg-2">
                              <div class="form-check form-check-inline">
                                <input id="renewalHelpNeededYes" type="radio" class="form-check-input" formControlName="renewalHelpNeeded" [value]="true" />
                                <label for="renewalHelpNeededYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-2 col-lg-2">
                              <div class="form-check form-check-inline">
                                <input id="renewalHelpNeededNo" type="radio" class="form-check-input" formControlName="renewalHelpNeeded" [value]="false" />
                                <label for="renewalHelpNeededNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        }
                        <!-- 'adminDifficulties' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Rencontrez-vous des difficultés administratives ou juridiques ?'" [control]="{ fg: detailForm, fcn: 'adminDifficulties' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="adminSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ adminSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Rencontrez-vous un point de blocage administratif qui nécessite un soutien particulier ?'" [control]="{ fg: detailForm, fcn: 'adminBlocking' }"></app-radios-input>
                                <app-radios-input [title]="'Besoin d’être guidé dans le cadre d\’un accès aux droits ?'" [control]="{ fg: detailForm, fcn: 'adminHelpForRights' }"></app-radios-input>
                                <app-radios-input [title]="'Rencontrez-vous un point de blocage juridique qui nécessite un soutien particulier ?'" [control]="{ fg: detailForm, fcn: 'adminJuridBlocking' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté liée à son avis d\'imposition ?'" [control]="{ fg: detailForm, fcn: 'adminTaxNotice' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <!-- 'readingWritingDifficulties' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Avez-vous besoin de développer vos capacités en lecture, écriture et/ou calcul ?'" [control]="{ fg: detailForm, fcn: 'readingWritingDifficulties' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="readingWritingDifficultiesSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ readingWritingDifficultiesSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Difficulté en français à l\'écrit'" [control]="{ fg: detailForm, fcn: 'readingWritingWrittenFrenchDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté en français en lecture'" [control]="{ fg: detailForm, fcn: 'readingWritingReadingFrenchDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté en français à l\'oral'" [control]="{ fg: detailForm, fcn: 'readingWritingOralFrenchDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté en calcul'" [control]="{ fg: detailForm, fcn: 'readingWritingMathDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Français Langue Étrangère (FLE)'" [control]="{ fg: detailForm, fcn: 'readingWritingFrenchAsForeignLanguage' }" [labels]="['Non maitrisé', 'En cours d\'apprentissage']"></app-radios-input>
                                <app-radios-input [title]="'Difficulté dans les apprentissages'" [control]="{ fg: detailForm, fcn: 'readingWritingLearningDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Si difficulté en français, quelqu\’un peut-il m\’aider dans mes démarches'" [control]="{ fg: detailForm, fcn: 'readingWritingHasFrenchSupportForProcedures' }"></app-radios-input>
                                <app-radios-input [title]="'Diagnostic linguistique effectué'" [control]="{ fg: detailForm, fcn: 'readingWritingLanguageAssessmentDone' }"></app-radios-input>
                                <div class="row mb-3">
                                  <div class="col-4">
                                    <label for="readingWritingLanguageAssessmentDoneDate" class="form-check-label">Si oui, quand</label>
                                    <app-datepicker id="readingWritingLanguageAssessmentDoneDate" formControlName="readingWritingLanguageAssessmentDoneDate"> </app-datepicker>
                                  </div>
                                  <div class="col-4">
                                    <label for="readingWritingLanguageAssessmentDoneResult" class="form-check-label">Résultat</label>
                                    <input id="readingWritingLanguageAssessmentDoneResult" type="text" class="form-control" formControlName="readingWritingLanguageAssessmentDoneResult" />
                                  </div>
                                </div>
                                <app-radios-input [nb]="3" [title]="'Mon niveau de langue est suffisant par rapport à mon projet professionnel'" [control]="{ fg: detailForm, fcn: 'readingWritingLanguageLevelSufficientForCareer' }" [values]="['true', 'false', 'do_not_know']"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Composition du foyer</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <!-- ********************************************************************************************* -->
                          <!-- In charge persons  -->
                          <app-dynamic-form #inChargePersons class="col-12" title="" [data]="assessment.inChargePersons" [showSeparator]="false" [fields]="inChargePersonsFields" [disabled]="!userCanUpdate" noGroupText="Il n'y a pas de personnes à charge renseigné. Cliquez sur le bouton + pour en ajouter.">
                            <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                              <!-- Category -->
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Catégorie</label>
                                <select class="form-select" formControlName="category" [class.is-invalid]="submitted && group?.controls.category.invalid">
                                  @for (category of inChargePersonCategoryMap | keyvalue: assessmentInChargePersonCategorySort; track category) {
                                    <option [ngValue]="category.key">
                                      {{ category.value }}
                                    </option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.category?.errors?.required) {
                                  <small class="form-text text-danger"> La catégorie est requise. </small>
                                }
                              </div>
                              <!-- Firstname / Lastname -->
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Nom</label>
                                <input type="text" class="form-control me-3 rounded" formControlName="lastName" [class.is-invalid]="submitted && group?.controls?.lastName?.invalid" />
                                @if (submitted && group?.controls?.lastName?.errors?.required) {
                                  <small class="form-text text-danger"> Le nom est requis. </small>
                                }
                                @if (submitted && group?.controls?.lastName?.errors?.maxlength) {
                                  <small class="form-text text-danger"> La taille maximale est de 30 caractères. </small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Prénom</label>
                                <input type="text" class="form-control me-3 rounded" formControlName="firstName" [class.is-invalid]="submitted && group?.controls?.firstName?.invalid" />
                                @if (submitted && group?.controls?.firstName?.errors?.required) {
                                  <small class="form-text text-danger"> Le prénom est requis. </small>
                                }
                                @if (submitted && group?.controls?.firstName?.errors?.maxlength) {
                                  <small class="form-text text-danger"> La taille maximale est de 30 caractères. </small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label for="birthDate" class="form-check-labe required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Date de naissance</label>
                                <app-datepicker id="birthDate" formControlName="birthDate" [invalid]="submitted && group?.controls.birthDate.invalid"> </app-datepicker>
                                @if (submitted && group?.controls?.birthDate?.errors?.required) {
                                  <small class="form-text text-danger"> La date de naissance est requise. </small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-4" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Situation scolaire ou pro.</label>
                                <div class="input-group">
                                  <select class="form-select me-3 rounded" formControlName="situation" [class.is-invalid]="submitted && group?.controls.situation.invalid">
                                    @for (situation of inChargePersonSituationMap | keyvalue: assessmentInChargePersonSituationSort; track situation) {
                                      <option [ngValue]="situation.key">
                                        {{ situation.value }}
                                      </option>
                                    }
                                  </select>
                                  <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" [disabled]="!userCanUpdate" (click)="groupRemoved(groupIndex)">
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                                @if (submitted && group?.controls?.situation?.errors?.required) {
                                  <small class="form-text text-danger"> La situation est requise.</small>
                                }
                              </div>
                            </ng-template>
                            <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                              <div class="row">
                                <div class="col-12 d-flex justify-content-between">
                                  <p>
                                    <strong>{{ title }}</strong>
                                  </p>
                                  <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" [disabled]="!userCanUpdate" (click)="groupAdded()">
                                    <fa-icon icon="plus"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                          </app-dynamic-form>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Child in progress -->
                        <div class="row mt-4">
                          <div class="col-8 col-lg-8">
                            <label>Attendez-vous un enfant ?</label>
                          </div>
                          <div class="col-2 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="childInProgressYes" type="radio" class="form-check-input" formControlName="childInProgress" [value]="true" />
                              <label for="childInProgressYes" class="form-check-label">Oui</label>
                            </div>
                          </div>
                          <div class="col-2 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="childInProgressNo" type="radio" class="form-check-input" formControlName="childInProgress" [value]="false" />
                              <label for="childInProgressNo" class="form-check-label">Non</label>
                            </div>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Is helper -->
                        <div class="row mt-4">
                          <div class="col-8 col-lg-8">
                            <label>Êtes-vous en situation d'aidant(e) ?</label>
                          </div>
                          <div class="col-2 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="isHelperYes" type="radio" class="form-check-input" formControlName="isHelper" name="isHelper" [value]="true" />
                              <label for="isHelperYes" class="form-check-label">Oui</label>
                            </div>
                          </div>
                          <div class="col-2 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="isHelperNo" type="radio" class="form-check-input" formControlName="isHelper" name="isHelper" [value]="false" />
                              <label for="isHelperNo" class="form-check-label">Non</label>
                            </div>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Family barriers -->
                        <!-- 'familyBarriers' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Avez-vous des contraintes familiales ?'" [control]="{ fg: detailForm, fcn: 'familyBarriers' }"></app-radios-input>
                          <div class="row mb-3">
                            <div class="col-12">
                              <label for="familyBarriersDetails" class="form-check-label">Si oui, précisez</label>
                              <input id="familyBarriersDetails" type="text" class="form-control" formControlName="familyBarriersDetails" />
                            </div>
                          </div>
                          <app-collapsable [(collapsed)]="familyBarriersSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ familyBarriersSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Avez-vous des enfants de moins de 3 ans sans solution de garde ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasChildUnder3WithoutChildcare' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous des modes de garde ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasChildcareArrangements' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous effectué des démarches pour rechercher un mode de garde ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasSearchedForChildcare' }"></app-radios-input>
                                <div class="row mb-3">
                                  <div class="col-4">
                                    <label for="familyBarriersHasSearchedForChildcareDetails" class="form-check-label">Si oui, lesquelles</label>
                                    <input id="familyBarriersHasSearchedForChildcareDetails" type="text" class="form-control" formControlName="familyBarriersHasSearchedForChildcareDetails" />
                                  </div>
                                </div>
                                <app-radios-input [title]="'Avez-vous en charge un enfant en situation de handicap ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasChildWithDisability' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous en charge un enfant ayant des problématiques de santé ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasChildWithHealthIssues' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous en charge un parent en situation de dépendance ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasDependentParent' }"></app-radios-input>
                                <app-radios-input [title]="'Êtes-vous accompagné, dans le cadre du problème de santé, handicap de votre enfant ou de la dépendance d\'un parent ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersReceivesSupportForFamilyCare' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous des contraintes horaires pour récupérer votre enfant ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasTimeConstraintsForChildPickup' }"></app-radios-input>
                                <div class="row mb-3">
                                  <div class="col-4">
                                    <label for="familyBarriersHasTimeConstraintsForChildPickupDetails" class="form-check-label">Si oui, lesquelles</label>
                                    <input id="familyBarriersHasTimeConstraintsForChildPickupDetails" type="text" class="form-control" formControlName="familyBarriersHasTimeConstraintsForChildPickupDetails" />
                                  </div>
                                </div>
                                <app-radios-input [title]="'Avez-vous d\'autres contraintes familiales à prendre en compte ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersHasOtherFamilyConstraints' }"></app-radios-input>
                                <app-radios-input [title]="'Souhaitez-vous bénéficier de conseils pour vous aider dans votre rôle de parent ?'" [control]="{ fg: detailForm, fcn: 'familyBarriersWantsParentingAdvice' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Mesures et aides spécifiques</strong></p>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- SIAE -->
                        <div class="row mt-2">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <app-radios-input [title]="'Agrément SIAE'" [control]="{ fg: detailForm, fcn: 'accreditationSIAE' }"></app-radios-input>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Fin d'agrément SIAE</label>
                            <app-datepicker id="fieldBirthDate" formControlName="accreditationSIAEDate"> </app-datepicker>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- RQTH -->
                        <div class="row mt-2">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <app-radios-input [nb]="3" [title]="'RQTH'" [control]="{ fg: detailForm, fcn: 'accreditationRQTH' }" [labels]="['Oui', 'Non', 'Demande en cours']" [values]="['Yes', 'No', 'PendingRequest']"></app-radios-input>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Fin de validité RQTH</label>
                            <app-datepicker id="fieldBirthDate" formControlName="accreditationRQTHDate"> </app-datepicker>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- AAH -->
                        <div class="row mt-2">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <app-radios-input [nb]="3" [title]="'Êtes-vous bénéficiaire de l\'AAH'" [control]="{ fg: detailForm, fcn: 'accreditationAAH' }" [labels]="['Oui', 'Non', 'Demande en cours']" [values]="['Yes', 'No', 'PendingRequest']"></app-radios-input>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Fin AAH</label>
                            <app-datepicker id="fieldBirthDate" formControlName="accreditationAAHDate"> </app-datepicker>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Health -->
                        <!-- 'health' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Avez-vous des problèmes de santé ?'" [control]="{ fg: detailForm, fcn: 'health' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="healthSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ healthSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Accès ou mise à jour de la couverture sécurité sociale et/ou mutuelle'" [control]="{ fg: detailForm, fcn: 'healthCoverageAccessOrUpdate' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous une couverture santé (type Complémentaire Santé solidaire) ?'" [control]="{ fg: detailForm, fcn: 'healthHasHealthCoverage' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous des difficultés de santé qui vous gênent dans votre quotidien ?'" [control]="{ fg: detailForm, fcn: 'healthDailyHealthDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté déclarée entravant l\’exercice de certains métiers'" [control]="{ fg: detailForm, fcn: 'healthLimitsSomeJobs' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté déclarée ne permettant pas de reprendre une activité professionnelle immédiate'" [control]="{ fg: detailForm, fcn: 'healthBlocksImmediateWorkReturn' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté déclarée entraînant des absences régulières'" [control]="{ fg: detailForm, fcn: 'healthCausesRegularAbsences' }"></app-radios-input>
                                <app-radios-input [title]="'Êtes-vous suivi(e) pour ces problèmes de santé ?'" [control]="{ fg: detailForm, fcn: 'healthHasMedicalFollowUp' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous accès à un médecin/aux soins ?'" [control]="{ fg: detailForm, fcn: 'healthMedicalAccess' }"></app-radios-input>
                                <app-radios-input [title]="'Souhaitez-vous qu\’on vous propose un soutien (accompagnement individuel et/ou collectif) pour accéder aux soins/aux droits de santé ?'" [control]="{ fg: detailForm, fcn: 'healthWantsSupportForCareAccess' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté à prendre conscience de la problématique de santé et/ou de handicap'" [control]="{ fg: detailForm, fcn: 'healthLacksAwarenessOfIssue' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté à intégrer la situation de santé et/ou de handicap dans son parcours'" [control]="{ fg: detailForm, fcn: 'healthStrugglesToIntegrateIssueInPath' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div ngbAccordionFooter>
                    <button class="btn btn-outline-secondary btn-sm" (click)="scroll(globalSituationAccordion)">Suivant</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * Validation -->
        <div class="ms-auto">
          @if (submitted && (assessmentForm.invalid || detailForm.invalid || inChargePersons.form.invalid)) {
            <small class="form-text text-danger"> Le formulaire n'est pas correctement complété. </small>
          }
        </div>
        <div class="row mt-4"></div>
        <!-- ********************************************************************************************* -->
        <!-- * GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOB * -->
        <!-- * GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOB * -->
        <!-- ********************************************************************************************* -->
        <div #globalSituationAccordion class="card border-1 card-border-radius-0" formGroupName="globalSituationForm">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button">Budget / Logement / Mobilité / Numérique / Accompagnement</button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <!-- ********************************************************************************************* -->
                        <!-- * Claim RSA -->
                        <div class="row">
                          <div class="col-12">
                            <p>
                              <strong>Qu'est ce qui vous a conduit à demander le RSA ?</strong>
                            </p>
                          </div>
                          <div class="col-12">
                            <div class="form-check">
                              <input id="claimRsaInsufRes" type="checkbox" class="form-check-input" formControlName="claimRsaInsufRes" />
                              <label class="form-check-label" for="claimRsaInsufRes">Ressources insuffisantes</label>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-check">
                              <input id="claimRsaNoRes" type="checkbox" class="form-check-input" formControlName="claimRsaNoRes" />
                              <label class="form-check-label" for="claimRsaNoRes">Absence de ressources</label>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-check">
                              <input id="claimRsaNoMoreUnemployRights" type="checkbox" class="form-check-input" formControlName="claimRsaNoMoreUnemployRights" />
                              <label class="form-check-label" for="claimRsaNoMoreUnemployRights">Fin du droit indemnités chômage</label>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-check">
                              <input id="claimRsaNoMoreUnemploy" type="checkbox" class="form-check-input" formControlName="claimRsaNoMoreUnemploy" />
                              <label class="form-check-label" for="claimRsaNoMoreUnemploy">Fin d’activité professionnelle de la personne et/ou du conjoint</label>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-check">
                              <input id="claimRsaRefugeeClaimant" type="checkbox" class="form-check-input" formControlName="claimRsaRefugeeClaimant" />
                              <label class="form-check-label" for="claimRsaRefugeeClaimant">Demandeur(se) d’asile</label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="form-check">
                              <input id="claimRsaOther" type="checkbox" class="form-check-input" formControlName="claimRsaOther" />
                              <label class="form-check-label" for="claimRsaOther">Autre (précisez)</label>
                            </div>
                          </div>
                          <div class="col-9">
                            <input type="text" class="form-control" formControlName="claimRsaOtherComment" />
                            @if (fcGSit?.claimRsaOtherComment?.errors?.maxlength) {
                              <small class="form-text text-danger"> La taille maximale est de 30 caractères. </small>
                            }
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Financial difficulties -->
                        <!-- 'financialDifficulties' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Rencontrez-vous des difficultés financières ?'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficulties' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="financialDifficultiesSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ financialDifficultiesSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Avez-vous d\'autres ressources que le RSA ?'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesHasOtherResourcesThanRSA' }"></app-radios-input>
                                <app-radios-input [title]="'Souhaitez-vous que soient étudiées les éventuelles aides possibles ?'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesAidNeeded' }"></app-radios-input>
                                <div class="row">
                                  <div class="col-12">
                                    <p><strong>Si oui, pour</strong></p>
                                  </div>
                                  <div class="col-12">
                                    <div class="form-check ps-5">
                                      <input id="financialDifficultiesAidNeededForRent" type="checkbox" class="form-check-input" formControlName="financialDifficultiesAidNeededForRent" />
                                      <label class="form-check-label" for="financialDifficultiesAidNeededForRent">Loyer</label>
                                    </div>
                                    <div class="form-check ps-5">
                                      <input id="financialDifficultiesAidNeededForEnergy" type="checkbox" class="form-check-input" formControlName="financialDifficultiesAidNeededForEnergy" />
                                      <label class="form-check-label" for="financialDifficultiesAidNeededForEnergy">Énergie</label>
                                    </div>
                                    <div class="form-check ps-5">
                                      <input id="financialDifficultiesAidNeededForFood" type="checkbox" class="form-check-input" formControlName="financialDifficultiesAidNeededForFood" />
                                      <label class="form-check-label" for="financialDifficultiesAidNeededForFood">Alimentation</label>
                                    </div>
                                    <div class="form-check ps-5">
                                      <input id="financialDifficultiesAidNeededForFines" type="checkbox" class="form-check-input" formControlName="financialDifficultiesAidNeededForFines" />
                                      <label class="form-check-label" for="financialDifficultiesAidNeededForFines">Amendes</label>
                                    </div>
                                    <div class="form-check ps-5">
                                      <input id="financialDifficultiesAidNeededForOther" type="checkbox" class="form-check-input" formControlName="financialDifficultiesAidNeededForOther" />
                                      <label class="form-check-label" for="financialDifficultiesAidNeededForOther">Autres</label>
                                    </div>
                                  </div>
                                </div>
                                <app-radios-input [title]="'Êtes-vous en situation d\’endettement ou de surendettement ?'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesHasDebtOrOverindebtedness' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté dans la gestion d\’un budget'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesHasBudgetManagementDifficulty' }"></app-radios-input>
                                <app-radios-input [title]="'Ressources précaires (inférieures au seuil de pauvreté)'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesIsBelowPovertyThreshold' }"></app-radios-input>
                                <app-radios-input [title]="'Bénéficie d\’un soutien financier par un tiers'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesReceivesThirdPartySupport' }"></app-radios-input>
                                <app-radios-input [title]="'Absence ou difficulté pour ouvrir un compte'" [control]="{ fg: globalSituationForm, fcn: 'financialDifficultiesHasBankingAccessIssue' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Residential status -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <strong>Quelle est votre situation par rapport au logement ?</strong>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="mb-3 text-secondary col-12 col-lg-12">
                            <label>Statut d'habitation</label>
                            <select class="form-select me-3 rounded" formControlName="residentialStatus" [class.is-invalid]="submitted && fcGSit.residentialStatus.invalid">
                              <option value=""></option>
                              @for (item of residentialStatusMap | keyvalue; track item) {
                                <option [ngValue]="item.key">
                                  {{ item.value }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Social exclusion -->
                        <div class="row mt-4">
                          <app-radios-input [nb]="3" [title]="'Êtes vous confronté à un problème d\'explusion ?'" [control]="{ fg: globalSituationForm, fcn: 'socialExclusion' }" [labels]="['Oui', 'Non', 'Pas de réponse']"></app-radios-input>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Indebtedness -->
                        <div class="row mt-4">
                          <app-radios-input [nb]="3" [title]="'Situation d\'impayé / endettement liée au logement ?'" [control]="{ fg: globalSituationForm, fcn: 'indebtedness' }" [labels]="['Oui', 'Non', 'Pas de réponse']"></app-radios-input>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Housing -->
                        <!-- 'housing' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Devez-vous faire face à des difficultés de logement ?'" [control]="{ fg: globalSituationForm, fcn: 'housing' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="housingSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ housingSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Logement inadapté (handicap, confort de vie…)'" [control]="{ fg: globalSituationForm, fcn: 'housingInadequate' }"></app-radios-input>
                                <app-radios-input [title]="'Logement insalubre'" [control]="{ fg: globalSituationForm, fcn: 'housingUnsanitary' }"></app-radios-input>
                                <app-radios-input [title]="'Je dois libérer mon hébergement ou mon logement prochainement'" [control]="{ fg: globalSituationForm, fcn: 'housingEvictionSoon' }"></app-radios-input>
                                <div class="row mb-3">
                                  <div class="col-5">
                                    <label for="housingEvictionSoonDetails" class="form-check-label">Si oui, pourquoi</label>
                                    <input id="housingEvictionSoonDetails" type="text" class="form-control" formControlName="housingEvictionSoonDetails" />
                                  </div>
                                </div>
                                <app-radios-input [title]="'J\’ai engagé des démarches de recherche de logement'" [control]="{ fg: globalSituationForm, fcn: 'housingSearchInProgress' }"></app-radios-input>
                                <div class="row mb-3">
                                  <div class="col-5">
                                    <label for="housingSearchInProgressDetails" class="form-check-label">Si oui, numéro unique d’enregistrement</label>
                                    <input id="housingSearchInProgressDetails" type="text" class="form-control" formControlName="housingSearchInProgressDetails" />
                                  </div>
                                </div>
                                <app-radios-input [title]="'Je suis accompagné(e) dans mes recherches de logement'" [control]="{ fg: globalSituationForm, fcn: 'housingSearchWithSupport' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Quels sont vos moyens et capacités de mobilité ?</strong></p>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Autonomous mobility -->
                        <div class="row mt-2">
                          <app-radios-input [nb]="3" [title]="'Capacité à se déplacer seul(e) ?'" [control]="{ fg: globalSituationForm, fcn: 'autonomousMobility' }" [labels]="['Oui', 'Non', 'Pas de réponse']"></app-radios-input>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Licence B -->
                        <div class="row mt-2">
                          <app-radios-input [nb]="4" [title]="'Permis B ?'" [control]="{ fg: globalSituationForm, fcn: 'licenceB' }" [labels]="['Oui', 'Non', 'En cours', 'Pas de réponse']" [values]="['Yes', 'No', 'PendingRequest', null]"></app-radios-input>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- *  TCL subscription -->
                        <div class="row mt-2">
                          <app-radios-input [nb]="3" [title]="'Abonnement TCL ?'" [control]="{ fg: globalSituationForm, fcn: 'tclSubscription' }" [labels]="['Oui', 'Non', 'Pas de réponse']" [values]="['Yes', 'No', null]"></app-radios-input>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Transport modes -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Moyens de transport</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <app-dynamic-form #transportModes class="col-12" title="" [data]="assessment.transportModes?.length ? assessment.transportModes : beneficiaryEmployment?.transportModes" [showSeparator]="false" [fields]="transportModesFields" [disabled]="!userCanUpdate" noGroupText="Il n'y a pas de moyen de transport renseignée. Cliquez sur le bouton + pour en ajouter.">
                            <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                              <div class="text-secondary mb-2 col-12 col-lg-6" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Moyen de transport</label>
                                <select class="form-select" formControlName="transportModeId" [class.is-invalid]="submitted && group?.controls.transportModeId.invalid">
                                  @for (transportMode of transportModeMap; track transportMode) {
                                    <option [ngValue]="transportMode.id">
                                      {{ transportMode.label }}
                                    </option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.transportModeId?.errors?.required) {
                                  <small class="form-text text-danger">Le moyen de transport est requis.</small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-6" [formGroup]="group">
                                <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Description</label>
                                <div class="input-group">
                                  <input type="text" class="form-control me-3 rounded" formControlName="description" [class.is-invalid]="submitted && group?.controls?.description?.invalid" />
                                  <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" [disabled]="!userCanUpdate" (click)="groupRemoved(groupIndex)">
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                              <div class="row">
                                <div class="col-12 d-flex justify-content-between">
                                  <p>
                                    <strong>{{ title }}</strong>
                                  </p>
                                  <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" [disabled]="!userCanUpdate" (click)="groupAdded()">
                                    <fa-icon icon="plus"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                          </app-dynamic-form>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Maximal mobility distance and time -->
                        <div class="row mt-4">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Rayon de mobilité maximum (km)</label>
                            <input type="number" class="form-control" formControlName="maxMobilityDistance" />
                            @if (submitted && fcGSit?.maxMobilityDistance?.errors?.pattern) {
                              <small class="form-text text-danger"> Seuls les chiffres sont autorisés. </small>
                            }
                          </div>
                          @if (submitted && fcGSit?.maxMobilityDistance?.errors?.pattern) {
                            <small class="form-text text-danger"> Seuls les chiffres sont autorisés. </small>
                          }
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Temps de trajet maximum (min)</label>
                            <input type="number" class="form-control" formControlName="maxMobilityGoToWorkTime" />
                            @if (submitted && fcGSit?.maxMobilityGoToWorkTime?.errors?.pattern) {
                              <small class="form-text text-danger"> Seuls les chiffres sont autorisés. </small>
                            }
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Mobility difficulties -->
                        <!-- 'mobilityDifficulties' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Rencontrez-vous des difficultés pour votre mobilité ?'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficulties' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="mobilityDifficultiesSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ mobilityDifficultiesSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Aucun moyen de transport à disposition'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesNoTransportAvailable' }"></app-radios-input>
                                <app-radios-input [title]="'Dépendant des transports en commun'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesDependentOnPublicTransport' }"></app-radios-input>
                                <app-radios-input [title]="'Savez-vous faire du vélo ?'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesCanRideBike' }"></app-radios-input>
                                <app-radios-input [title]="'Si oui, avec mon propre vélo ? avec vélo’v ?'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesOwnBikeOrSharedBike' }"></app-radios-input>
                                <app-radios-input [title]="'Pensez-vous avoir besoin du permis pour votre projet professionnel ?'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesNeedsDrivingLicenseForJob' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous un permis étranger (hors EEE) ?'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesHasForeignLicenseOutsideEEE' }"></app-radios-input>
                                <app-radios-input [title]="'État de santé déclaré rendant incompatible la conduite'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesHealthPreventsDriving' }"></app-radios-input>
                                <app-radios-input [title]="'État de santé déclaré limitant la mobilité par la conduite et/ou l\’utilisation des transports en commun'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesHealthLimitsOverallMobility' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous besoin d\’un permis de conduire aménagé ?'" [control]="{ fg: globalSituationForm, fcn: 'mobilityDifficultiesNeedsAdaptedDrivingLicense' }"></app-radios-input>
                                <label>Si vous n’êtes pas à l’aise pour vous déplacer dans un endroit non connu, quelles en sont les causes ?</label>
                                <div class="col-12">
                                  <div class="form-check ps-5">
                                    <input id="mobilityDifficultiesDifficultyReadingInformation" type="checkbox" class="form-check-input" formControlName="mobilityDifficultiesDifficultyReadingInformation" />
                                    <label class="form-check-label" for="mobilityDifficultiesDifficultyReadingInformation">Difficultés de lecture des informations</label>
                                  </div>
                                  <div class="form-check ps-5">
                                    <input id="mobilityDifficultiesStressWhenTraveling" type="checkbox" class="form-check-input" formControlName="mobilityDifficultiesStressWhenTraveling" />
                                    <label class="form-check-label" for="mobilityDifficultiesStressWhenTraveling">Stress</label>
                                  </div>
                                  <div class="form-check ps-5">
                                    <input id="mobilityDifficultiesUnfamiliarWithTCLApps" type="checkbox" class="form-check-input" formControlName="mobilityDifficultiesUnfamiliarWithTCLApps" />
                                    <label class="form-check-label" for="mobilityDifficultiesUnfamiliarWithTCLApps">Méconnaissance des applications du réseau TCL</label>
                                  </div>
                                  <div class="form-check ps-5">
                                    <input id="mobilityDifficultiesPoorSenseOfDirection" type="checkbox" class="form-check-input" formControlName="mobilityDifficultiesPoorSenseOfDirection" />
                                    <label class="form-check-label" for="mobilityDifficultiesPoorSenseOfDirection">Difficultés de sens d’orientation</label>
                                  </div>
                                  <div class="form-check ps-5">
                                    <input id="mobilityDifficultiesUnawareOfExistingTransportOptions" type="checkbox" class="form-check-input" formControlName="mobilityDifficultiesUnawareOfExistingTransportOptions" />
                                    <label class="form-check-label" for="mobilityDifficultiesUnawareOfExistingTransportOptions">Méconnaissance des moyens de transports existants</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Numeric difficulties -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Votre situation vis-à-vis du numérique</strong></p>
                          </div>
                        </div>
                        <!-- 'numericDifficulties' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Êtes-vous à l\'aise sur le numérique ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficulties' }" [values]="[false, true, null]"></app-radios-input>
                          <app-collapsable [(collapsed)]="numericDifficultiesSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ numericDifficultiesSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Disposez-vous d\'un outil numérique ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasDevice' }"></app-radios-input>
                                <div class="col-12">
                                  <p><strong>Si oui</strong></p>
                                </div>
                                <div class="col-12">
                                  <div class="form-check ps-5">
                                    <input id="numericDifficultiesHasComputer" type="checkbox" class="form-check-input" formControlName="numericDifficultiesHasComputer" />
                                    <label class="form-check-label" for="numericDifficultiesHasComputer">Ordinateur</label>
                                  </div>
                                  <div class="form-check ps-5">
                                    <input id="numericDifficultiesHasSmartphone" type="checkbox" class="form-check-input" formControlName="numericDifficultiesHasSmartphone" />
                                    <label class="form-check-label" for="numericDifficultiesHasSmartphone">Smartphone</label>
                                  </div>
                                  <div class="form-check ps-5">
                                    <input id="numericDifficultiesHasTablet" type="checkbox" class="form-check-input" formControlName="numericDifficultiesHasTablet" />
                                    <label class="form-check-label" for="numericDifficultiesHasTablet">Tablette</label>
                                  </div>
                                </div>
                                <app-radios-input [title]="'Si vous êtes équipé, vous en servez-vous seul ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesUsesDeviceAlone' }"></app-radios-input>
                                <app-radios-input [title]="'Disposez-vous d\'une connexion internet ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasInternetAccess' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous une adresse de messagerie (email) ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasEmail' }"></app-radios-input>
                                <app-radios-input [title]="'Le cas échéant, avez-vous un équipement adapté à la situation de handicap ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasAccessibleDevice' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous un compte France Connect ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasFranceConnect' }"></app-radios-input>
                                <app-radios-input [title]="'Avez-vous une identité numérique ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasDigitalID' }"></app-radios-input>
                                <app-radios-input [title]="'Difficulté à réaliser des démarches administratives en ligne'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasDifficultyWithOnlineProcedures' }"></app-radios-input>
                                <app-radios-input [title]="'Dispose d\'un espace public proposant un accès au numérique'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesHasPublicAccessToTech' }"></app-radios-input>
                                <app-radios-input [title]="'Connaissez-vous les lieux qui peuvent vous aider ?'" [control]="{ fg: globalSituationForm, fcn: 'numericDifficultiesKnowsHelpLocations' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Assistance -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Votre accompagnement</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-8 col-lg-12">Bénéficiez-vous d'une aide ?</div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-2 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="assistanceYes" type="radio" class="form-check-input" formControlName="assistance" [value]="true" />
                              <label for="assistanceYes" class="form-check-label">Oui</label>
                            </div>
                          </div>
                          <div class="col-2 col-lg-2">
                            <div class="form-check form-check-inline">
                              <input id="assistanceNo" type="radio" class="form-check-input" formControlName="assistance" [value]="false" />
                              <label for="assistanceNo" class="form-check-label">Non</label>
                            </div>
                          </div>
                          <div class="col-2 col-lg-8">
                            <div class="form-check form-check-inline">
                              <input id="assistanceNoAnswer" type="radio" class="form-check-input" formControlName="assistance" [value]="null" />
                              <label for="assistanceNoAnswer" class="form-check-label">Pas de réponse</label>
                            </div>
                          </div>
                        </div>
                        @if (fvGSit.assistance) {
                          <div class="row mt-2">
                            <div class="col-12">
                              <div class="form-check">
                                <input id="assistedByConseiller" type="checkbox" class="form-check-input" formControlName="assistedByConseiller" />
                                <label class="form-check-label" for="assistedByConseiller">Par un(e) conseiller(e) d'insertion / emploi</label>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-check">
                                <input id="assistedByTravailleurSocial" type="checkbox" class="form-check-input" formControlName="assistedByTravailleurSocial" />
                                <label class="form-check-label" for="assistedByTravailleurSocial">Par un(e) travailleur social(e)</label>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-check">
                                <input id="assistedByAssociation" type="checkbox" class="form-check-input" formControlName="assistedByAssociation" />
                                <label class="form-check-label" for="assistedByAssociation">Par une association</label>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-check">
                                <input id="assistedByFamilleAmis" type="checkbox" class="form-check-input" formControlName="assistedByFamilleAmis" />
                                <label class="form-check-label" for="assistedByFamilleAmis">Par ma famille, mes amis</label>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-check">
                                <input id="assistedByAutre" type="checkbox" class="form-check-input" formControlName="assistedByAutre" />
                                <label class="form-check-label" for="assistedByAutre">Par d'autres personnes ou organismes</label>
                              </div>
                            </div>
                          </div>
                        }
                        <!-- ********************************************************************************************* -->
                        <!-- Social -->
                        <!-- 'socialSatisfaction' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Êtes-vous satisfait par votre environnement social ?'" [control]="{ fg: globalSituationForm, fcn: 'socialSatisfaction' }"></app-radios-input>
                          <app-collapsable [(collapsed)]="socialSatisfactionSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ socialSatisfactionSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [nb]="3" [title]="'Vous autorisez-vous à prendre du temps pour vous, pour faire des activités qui vous plaisent ?'" [control]="{ fg: globalSituationForm, fcn: 'socialSelfCareTime' }" [labels]="['Oui', 'Non', 'Ne souhaite pas répondre']" [values]="['Yes', 'No', 'NoAnswer']"></app-radios-input>
                                <app-radios-input [nb]="3" [title]="'Vous sentez-vous à l\'aise dans un groupe ?'" [control]="{ fg: globalSituationForm, fcn: 'socialGroupComfort' }" [labels]="['Oui', 'Non', 'Ne souhaite pas répondre']" [values]="['Yes', 'No', 'NoAnswer']"></app-radios-input>
                                <app-radios-input [nb]="3" [title]="'Ressentez-vous du stress lorsque vous rencontrez de nouvelles personnes ?'" [control]="{ fg: globalSituationForm, fcn: 'socialNewPeopleStress' }" [labels]="['Oui', 'Non', 'Ne souhaite pas répondre']" [values]="['Yes', 'No', 'NoAnswer']"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div ngbAccordionFooter>
                    <button class="btn btn-outline-secondary btn-sm" (click)="scroll(detailAccordion)">Précédent</button>
                    <button class="btn btn-outline-secondary btn-sm" (click)="scroll(orientationAccordion)">Suivant</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * Validation -->
        <div class="ms-auto">
          @if (submitted && (assessmentForm.invalid || globalSituationForm.invalid || transportModes.form.invalid)) {
            <small class="form-text text-danger"> Le formulaire n'est pas correctement complété. </small>
          }
        </div>
        <div class="row mt-4"></div>
        <!-- ********************************************************************************************* -->
        <!-- * ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIEN * -->
        <!-- * ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIEN * -->
        <!-- ********************************************************************************************* -->
        <div #orientationAccordion class="card border-1 card-border-radius-0" formGroupName="orientationForm">
          <div class="card-body p-0">
            <div class="table-responsive">
              <div ngbAccordion [closeOthers]="false">
                <div ngbAccordionItem>
                  <h2 ngbAccordionHeader>
                    <button ngbAccordionButton class="accordion-button">Vos projets et votre orientation</button>
                  </h2>
                  <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                      <ng-template>
                        <!-- ********************************************************************************************* -->
                        <!-- Degree -->
                        <div class="row">
                          <div class="col-12 col-lg-12">
                            <p>
                              <strong>Niveau d'études, formations, qualifications</strong>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Niveau d'étude</label>
                            <div class="mb-3 text-secondary">
                              <select class="form-select" formControlName="degreeId" [class.is-invalid]="submitted && fcOri.degreeId.invalid">
                                <option value=""></option>
                                @for (degree of degrees; track degree) {
                                  <option [ngValue]="degree.id">
                                    {{ degree.label }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Études à l'étranger ?</label>
                            <div class="row">
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="studyAbroadYes" type="radio" class="form-check-input" formControlName="studyAbroad" [value]="true" />
                                  <label for="studyAbroadYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="studyAbroadNo" type="radio" class="form-check-input" formControlName="studyAbroad" [value]="false" />
                                  <label for="studyAbroadNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 col-lg-6">
                            <div class="mb-3 text-secondary">
                              <label>Intitulé du diplôme</label>
                              <input type="text" class="form-control" formControlName="degreeLabel" />
                            </div>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Diplôme obtenu ?</label>
                            <div class="row">
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="degreeGainedYes" type="radio" class="form-check-input" formControlName="degreeGained" [value]="true" />
                                  <label for="degreeGainedYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="degreeGainedNo" type="radio" class="form-check-input" formControlName="degreeGained" [value]="false" />
                                  <label for="degreeGainedNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="mb-3 text-secondary col-12 col-lg-12">
                            <label>Domaines de formation</label>
                            <div class="mb-3 text-secondary">
                              <ng-select formControlName="trainingAreaIds" [items]="trainingAreas" bindValue="id" bindLabel="label" [multiple]="true" [closeOnSelect]="false"></ng-select>
                            </div>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Formations -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Formations hors cursus scolaire</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <app-dynamic-form #formations class="col-12" title="" [data]="assessment.formations" [showSeparator]="false" [fields]="formationsFields" [disabled]="!userCanUpdate" noGroupText="Il n'y a pas de formation renseignée. Cliquez sur le bouton + pour en ajouter.">
                            <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Intitulé</label>
                                <input type="text" class="form-control me-3 rounded" formControlName="label" [class.is-invalid]="submitted && group?.controls?.label?.invalid" />
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-4" [formGroup]="group">
                                <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Début</label>
                                <app-datepicker id="fieldBeginDate" formControlName="beginDate"></app-datepicker>
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-5" [formGroup]="group">
                                <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0"> Fin </label>
                                <div class="input-group">
                                  <app-datepicker id="fieldEndDate" formControlName="endDate" class="me-3"></app-datepicker>
                                  <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" [disabled]="!userCanUpdate" (click)="groupRemoved(groupIndex)">
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                              <div class="row">
                                <div class="col-12 d-flex justify-content-between">
                                  <p>
                                    <strong>{{ title }}</strong>
                                  </p>
                                  <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" [disabled]="!userCanUpdate" (click)="groupAdded()">
                                    <fa-icon icon="plus"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                          </app-dynamic-form>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Activity -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p>
                              <strong>Êtes-vous en activité ?</strong>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <div class="row">
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="isActiveYes" type="radio" class="form-check-input" formControlName="isActive" [value]="true" />
                                  <label for="isActiveYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="isActiveNo" type="radio" class="form-check-input" formControlName="isActive" [value]="false" />
                                  <label for="isActiveNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            @if (fvOri.isActive === true) {
                              <div>
                                <label>Si oui</label>
                                <select class="form-select" formControlName="activity" [class.is-invalid]="submitted && orientationForm?.controls.activity.invalid">
                                  @for (activity of activityMap | keyvalue: assessmentActivitySort; track activity) {
                                    <option [ngValue]="activity.key">
                                      {{ activity.value }}
                                    </option>
                                  }
                                </select>
                              </div>
                            }
                            @if (fvOri.isActive === false) {
                              <div>
                                <label>Si non</label>
                                <select class="form-select" formControlName="unactivity" [class.is-invalid]="submitted && orientationForm?.controls.unactivity.invalid">
                                  @for (unactivity of unactivityMap | keyvalue: assessmentUnactivitySort; track unactivity) {
                                    <option [ngValue]="unactivity.key">
                                      {{ unactivity.value }}
                                    </option>
                                  }
                                </select>
                              </div>
                            }
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Has worked -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p>
                              <strong>Avez-vous déjà travaillé ?</strong>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <div class="row">
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="hasWorkedYes" type="radio" class="form-check-input" formControlName="hasWorked" [value]="true" />
                                  <label for="hasWorkedYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="hasWorkedNo" type="radio" class="form-check-input" formControlName="hasWorked" [value]="false" />
                                  <label for="hasWorkedNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          @if (fvOri.hasWorked === true) {
                            <div class="mb-3 text-secondary col-12 col-lg-6">
                              <label>Si oui, il y a combien de temps ?</label>
                              <select class="form-select" formControlName="howLongHasWorked" [class.is-invalid]="submitted && orientationForm?.controls.howLongHasWorked.invalid">
                                @for (howLongHasWorked of howLongHasWorkedMap | keyvalue: assessmentHowLongHasWorkedSort; track howLongHasWorked) {
                                  <option [ngValue]="howLongHasWorked.key">
                                    {{ howLongHasWorked.value }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Pro exp -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Expériences significatives</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <app-dynamic-form #proExps class="col-12" title="" [data]="assessment.proExps" [showSeparator]="false" [fields]="proExpsFields" [disabled]="!userCanUpdate" noGroupText="Il n'y a pas d'expérience renseignée. Cliquez sur le bouton + pour en ajouter.">
                            <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                              <!-- Job -->
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Poste</label>
                                <input type="text" class="form-control me-3 rounded" formControlName="job" [class.is-invalid]="submitted && group?.controls?.job?.invalid" />
                                @if (submitted && group?.controls?.job?.errors?.required) {
                                  <small class="form-text text-danger"> Le champ est obligatoire. </small>
                                }
                              </div>
                              <!-- Contract type -->
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Type de contrat</label>
                                <select class="form-select" formControlName="contractType" [class.is-invalid]="submitted && group?.controls?.contractType?.invalid">
                                  <option value=""></option>
                                  @for (contractType of contractTypesMap | keyvalue: assessmentContractTypesSort; track contractType) {
                                    <option [ngValue]="contractType.key">
                                      {{ contractType.value }}
                                    </option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.contractType?.errors?.required) {
                                  <small class="form-text text-danger"> Le champ est obligatoire. </small>
                                }
                              </div>
                              <!-- Duration -->
                              <div class="text-secondary mb-2 col-12 col-lg-2" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Durée</label>
                                <select class="form-select me-3 rounded" formControlName="duration" [class.is-invalid]="submitted && group?.controls.duration.invalid">
                                  @for (duration of proExpDurationMap | keyvalue: assessmentProExpDurationSort; track duration) {
                                    <option [ngValue]="duration.key">
                                      {{ duration.value }}
                                    </option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.duration?.errors?.required) {
                                  <small class="form-text text-danger"> Le champ est obligatoire. </small>
                                }
                              </div>
                              <!-- Begin date -->
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Date de début</label>
                                <app-datepicker id="fieldBeginDate" formControlName="beginDate"></app-datepicker>
                              </div>
                              <!-- End date -->
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Date de fin</label>
                                <div class="input-group">
                                  <app-datepicker id="fieldEndDate" formControlName="endDate"></app-datepicker>
                                  <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary ms-3 rounded" [disabled]="!userCanUpdate" (click)="groupRemoved(groupIndex)">
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                              <div class="row">
                                <div class="col-12 d-flex justify-content-between">
                                  <p>
                                    <strong>{{ title }}</strong>
                                  </p>
                                  <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" [disabled]="!userCanUpdate" (click)="groupAdded()">
                                    <fa-icon icon="plus"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                          </app-dynamic-form>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Job searching -->
                        <!-- Searching for new job -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p>
                              <strong>Recherchez vous un emploi ?</strong>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <div class="row">
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="searchingForJobYes" type="radio" class="form-check-input" formControlName="searchingForJob" [value]="true" />
                                  <label for="searchingForJobYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-4">
                                <div class="form-check form-check-inline">
                                  <input id="searchingForJobNo" type="radio" class="form-check-input" formControlName="searchingForJob" [value]="false" />
                                  <label for="searchingForJobNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            @if (fvOri.searchingForJob === false) {
                              <div class="mb-3 text-secondary col-12 col-lg-12">
                                <label>Si non, pourquoi ?</label>
                                <input type="text" class="form-control" formControlName="searchingForJobReasonNotTo" />
                              </div>
                            }
                          </div>
                        </div>
                        <!-- Ready for new job -->
                        <div class="row mt-4">
                          <div class="mb-3 text-secondary col-12 col-lg-12">
                            <label>Êtes vous disponible pour reprendre une activité professionnelle ?</label>
                            <div class="row">
                              <div class="col-4 col-lg-2">
                                <div class="form-check form-check-inline">
                                  <input id="readyForNewJobYes" type="radio" class="form-check-input" formControlName="readyForNewJob" [value]="true" />
                                  <label for="readyForNewJobYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-2">
                                <div class="form-check form-check-inline">
                                  <input id="readyForNewJobNo" type="radio" class="form-check-input" formControlName="readyForNewJob" [value]="false" />
                                  <label for="readyForNewJobNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            @if (fvOri.readyForNewJob === false) {
                              <div class="mb-3 text-secondary col-12 col-lg-12">
                                <label>Si non, pourquoi ?</label>
                                <input type="text" class="form-control" formControlName="readyForNewJobReasonNotTo" />
                              </div>
                            }
                          </div>
                        </div>
                        <!-- Job center -->
                        <div class="row mt-4">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Êtes-vous inscrit à France Travail ?</label>
                            <select class="form-select me-3 rounded" formControlName="jobCenterRegistration" [class.is-invalid]="submitted && fcOri.jobCenterRegistration.invalid">
                              @for (item of jobCenterRegistrationMap | keyvalue: assessmentJobCenterRegistrationSort; track item) {
                                <option [ngValue]="item.key">
                                  {{ item.value }}
                                </option>
                              }
                            </select>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Depuis quand</label>
                            <app-datepicker id="fieldBirthDate" formControlName="jobCenterLastUpdateDate"> </app-datepicker>
                          </div>
                          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                            <label>Quelles démarches d'insertion avez-vous engagées ?</label>
                            <textarea formControlName="integrationStepsTaken" type="text" class="form-control"></textarea>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Professionnal Project -->
                        <!-- 'professionalProject' sub-accordion -->
                        <div class="row mt-4 sub-accordion">
                          <app-radios-input [title]="'Avez-vous un projet professionnel ?'" [control]="{ fg: orientationForm, fcn: 'professionalProjectHasDefinedCreationProject' }"></app-radios-input>
                          <div class="row mb-3">
                            <div class="col-12">
                              <label for="professionnalProjectDetails" class="form-check-label">Si oui, précisez</label>
                              <input id="professionnalProjectDetails" type="text" class="form-control" formControlName="professionnalProjectDetails" />
                            </div>
                          </div>
                          <app-collapsable [(collapsed)]="professionalProjectSubAccordionCollapse">
                            <div toggle class="mt-3">
                              <span role="button" class="text-decoration-underline"> {{ professionalProjectSubAccordionCollapse ? 'Afficher' : 'Masquer' }} les questions complémentaires </span>
                            </div>
                            <div collapsable>
                              <div class="sub-accordion-content">
                                <app-radios-input [title]="'Je sais comment activer une recherche d’emploi'" [control]="{ fg: orientationForm, fcn: 'professionalProjectKnowsHowToConductJobSearch' }"></app-radios-input>
                                <app-radios-input [title]="'Mon projet nécessite-t-il une formation ?'" [control]="{ fg: orientationForm, fcn: 'professionalProjectRequiresTraining' }"></app-radios-input>
                                <app-radios-input [title]="'Si mon projet inclut une formation, vais-je matériellement pouvoir la suivre (financement, sélection...) ?'" [control]="{ fg: orientationForm, fcn: 'professionalProjectCanFollowUpOnTraining' }"></app-radios-input>
                                <app-radios-input [title]="'Je connais les techniques de recherche d\'emploi et je sais m\'en saisir (mettre en avant mes compétences, développer mon réseau, CV...)'" [control]="{ fg: orientationForm, fcn: 'professionalProjectKnowsJobSearchTechniques' }"></app-radios-input>
                                <app-radios-input [title]="'Si je souhaite créer une entreprise, j\'ai défini mon projet de création'" [control]="{ fg: orientationForm, fcn: 'professionalProjectHasDefinedCreationProject' }"></app-radios-input>
                              </div>
                            </div>
                          </app-collapsable>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Access to formation -->
                        <div class="row mt-4">
                          <app-radios-input [title]="'Avez-vous besoin d\'aide dans l\'accès à la formation ?'" [control]="{ fg: orientationForm, fcn: 'accessToFormation' }"></app-radios-input>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Job Soughts -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Postes recherchés</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <app-dynamic-form #jobSoughts class="col-12" title="" [data]="employmentJobs" [showSeparator]="false" [fields]="jobSoughtsFields" [disabled]="!userCanUpdate" noGroupText="Il n'y a pas de postes recherchés. Cliquez sur le bouton + pour en ajouter.">
                            <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Famille</label>
                                <select class="form-select" formControlName="famillyWantedJobType" [class.is-invalid]="submitted && group?.controls?.famillyWantedJobType?.errors?.required" (change)="handleSectorChange(group)">
                                  <option value="" hidden></option>
                                  @for (sector of sectors; track sector) {
                                    <option [ngValue]="sector">{{ sector.label }}</option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.famillyWantedJobType?.errors?.required) {
                                  <small class="form-text text-danger">La famille est requise.</small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Domaine professionnel</label>
                                <select class="form-select" formControlName="domainWantedJobType" [attr.disabled]="group?.controls?.famillyWantedJobType?.value ? null : ''" [class.is-invalid]="submitted && group?.controls?.domainWantedJobType?.errors?.required" (change)="handleDomainChange(group)">
                                  <option value="" hidden></option>
                                  @for (domain of group?.controls?.famillyWantedJobType?.value?.subValues; track domain) {
                                    <option [ngValue]="domain">
                                      {{ domain.label }}
                                    </option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.domainWantedJobType?.errors?.required) {
                                  <small class="form-text text-danger">Le domaine est requis.</small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Métier</label>
                                <select class="form-select me-3 rounded" formControlName="wantedJobType" [attr.disabled]="group?.controls?.domainWantedJobType?.value ? null : ''" [class.is-invalid]="submitted && group?.controls?.wantedJobType?.errors?.required">
                                  <option value="" hidden></option>
                                  @for (job of group?.controls?.domainWantedJobType?.value?.subValues; track job) {
                                    <option [ngValue]="job">
                                      {{ job.label }}
                                    </option>
                                  }
                                </select>
                                @if (submitted && group?.controls?.domainWantedJobType?.errors?.required) {
                                  <small class="form-text text-danger">Le métier est requis.</small>
                                }
                              </div>
                              <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                                <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Expérience</label>
                                <div class="input-group">
                                  <select class="form-select me-3 rounded" formControlName="experienceLength" [attr.disabled]="group?.controls?.wantedJobType?.value ? null : ''">
                                    <option value=""></option>
                                    @for (experienceLength of experienceLengthMap | keyvalue: assessmentExperienceLengthSort; track experienceLength) {
                                      <option [ngValue]="experienceLength.key">
                                        {{ experienceLength.value }}
                                      </option>
                                    }
                                  </select>
                                  <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" [disabled]="!userCanUpdate" (click)="groupRemoved(groupIndex)">
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                            <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                              <div class="row">
                                <div class="col-12 d-flex justify-content-between">
                                  <p>
                                    <strong>{{ title }}</strong>
                                  </p>
                                  <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" [disabled]="!userCanUpdate" (click)="groupAdded()">
                                    <fa-icon icon="plus"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                          </app-dynamic-form>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Contract type -->
                        <div class="row mt-4">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Quel type de contrat recherchez-vous ?</label>
                            <div class="mb-3 text-secondary">
                              <select class="form-select" formControlName="contractSearchType" [class.is-invalid]="submitted && fcOri.contractSearchType.invalid">
                                <option value=""></option>
                                @for (contractType of contractTypesMap | keyvalue: assessmentContractTypesSort; track contractType) {
                                  <option [ngValue]="contractType.key">
                                    {{ contractType.value }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Working time -->
                        <div class="row mt-4">
                          <div class="mb-3 text-secondary col-12 col-lg-6">
                            <label>Temps de travail</label>
                            <div class="mb-3 text-secondary">
                              <select class="form-select" formControlName="workingTime" [class.is-invalid]="submitted && fcOri.workingTime.invalid">
                                <option value=""></option>
                                @for (workingTime of workingTimeMap | keyvalue: assessmentWorkingTimeSort; track workingTime) {
                                  <option [ngValue]="workingTime.key">
                                    {{ workingTime.value }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- Assets -->
                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Atouts</strong></p>
                          </div>
                        </div>
                        <div class="row mt-2">
                          <app-dynamic-form #advantages class="col-12" title="" [data]="assessment.advantages" [showSeparator]="false" [fields]="advantagesFields" [disabled]="!userCanUpdate" noGroupText="Il n'y a pas d'atout renseigné. Cliquez sur le bouton + pour en ajouter.">
                            <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                              <!-- Asset -->
                              <div class="text-secondary mb-2 col-12 col-lg-4" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Atout</label>
                                <div class="input-group">
                                  <select class="form-select me-3 rounded" formControlName="assetId" [class.is-invalid]="submitted && group?.controls.assetId.invalid">
                                    @for (asset of assets; track asset) {
                                      <option [ngValue]="asset.id">
                                        {{ asset.label }}
                                      </option>
                                    }
                                  </select>
                                </div>
                                @if (submitted && group?.controls?.assetId?.errors?.required) {
                                  <small class="form-text text-danger"> Le champ est obligatoire. </small>
                                }
                              </div>
                              <!-- Description -->
                              <div class="text-secondary mb-2 col-12 col-lg-8" [formGroup]="group">
                                <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Description</label>
                                <div class="input-group">
                                  <input type="text" class="form-control me-3 rounded" formControlName="description" [class.is-invalid]="submitted && group?.controls?.description?.invalid" />
                                  <button type="button" ngbTooltip="Supprimer" placement="left" class="btn btn-outline-primary rounded" [disabled]="!userCanUpdate" (click)="groupRemoved(groupIndex)">
                                    <fa-icon icon="trash-alt"></fa-icon>
                                  </button>
                                </div>
                                @if (submitted && group?.controls?.description?.errors?.required) {
                                  <small class="form-text text-danger"> Le champ est obligatoire. </small>
                                }
                              </div>
                            </ng-template>
                            <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                              <div class="row">
                                <div class="col-12 d-flex justify-content-between">
                                  <p>
                                    <strong>{{ title }}</strong>
                                  </p>
                                  <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" [disabled]="!userCanUpdate" (click)="groupAdded()">
                                    <fa-icon icon="plus"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            </ng-template>
                          </app-dynamic-form>
                        </div>
                        <!-- ********************************************************************************************* -->
                        <!-- * Expectations regarding RSA -->
                        <div class="row mt-4">
                          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                            <label>Quelles sont vos attentes vis-à-vis de l'accompagnement lié au RSA ?</label>
                            <textarea formControlName="expectationsRegardingRSA" type="text" class="form-control"></textarea>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                  <div ngbAccordionFooter>
                    <button class="btn btn-outline-secondary btn-sm" (click)="scroll(globalSituationAccordion)">Précédent</button>
                    @if (supportAvailable) {
                      <button class="btn btn-outline-secondary btn-sm" (click)="scroll(supportAccordion)">Suivant</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * Validation -->
        <div class="ms-auto">
          @if (submitted && (assessmentForm.invalid || orientationForm.invalid || proExps.form.invalid || formations.form.invalid || jobSoughts.form.invalid || advantages.form.invalid)) {
            <small class="form-text text-danger"> Le formulaire n'est pas correctement complété. </small>
          }
        </div>
        <div class="row mt-4"></div>
        <!-- ********************************************************************************************* -->
        <!-- * SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT S * -->
        <!-- * SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT S * -->
        <!-- ********************************************************************************************* -->
        <div #supportAccordion>
          <!-- #supportAccordion Not included in next div because "ngIf" makes type differ from other accordions -->
          @if (supportAvailable) {
            <div class="card border-1 card-border-radius-0" formGroupName="supportForm">
              <div class="card-body p-0">
                <div class="table-responsive">
                  <div ngbAccordion [closeOthers]="false">
                    <div ngbAccordionItem>
                      <h2 ngbAccordionHeader>
                        <button ngbAccordionButton class="accordion-button">Accompagnement proposé</button>
                      </h2>
                      <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                          <ng-template>
                            <!-- Support proposal -->
                            <div class="mb-3 col-12 col-lg-4">
                              <label class="text-secondary">Proposition de parcours</label>
                              <select class="form-select" formControlName="supportProposal">
                                <option value=""></option>
                                @for (supportProposal of supportProposalMap | keyvalue: stringAscOrder; track supportProposal) {
                                  <option [ngValue]="supportProposal.key">
                                    {{ supportProposal.value }}
                                  </option>
                                }
                              </select>
                            </div>
                            <!-- ********************************************************************************************* -->
                            <!-- Support acceptance -->
                            <div class="row mt-4">
                              <label>L'allocataire adhère à la proposition / décision d'orientation</label>
                              <div class="col-4 col-lg-2">
                                <div class="form-check form-check-inline">
                                  <input id="supportAcceptanceYes" type="radio" class="form-check-input" formControlName="supportAcceptance" [value]="true" />
                                  <label for="supportAcceptanceYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-2">
                                <div class="form-check form-check-inline">
                                  <input id="supportAcceptanceNo" type="radio" class="form-check-input" formControlName="supportAcceptance" [value]="false" />
                                  <label for="supportAcceptanceNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                              <div class="col-2 col-lg-8">
                                <div class="form-check form-check-inline">
                                  <input id="supportAcceptanceNoAnswer" type="radio" class="form-check-input" formControlName="supportAcceptance" [value]="null" />
                                  <label for="supportAcceptanceNoAnswer" class="form-check-label">Pas de réponse</label>
                                </div>
                              </div>
                            </div>
                            <!-- ********************************************************************************************* -->
                            <!-- Data sharing acceptance -->
                            <div class="row mt-4">
                              <label>Accord pour la transmission des informations au futur référent RSA et France Travail</label>
                              <div class="col-4 col-lg-2">
                                <div class="form-check form-check-inline">
                                  <input id="dataSharingAcceptanceYes" type="radio" class="form-check-input" formControlName="dataSharingAcceptance" [value]="true" />
                                  <label for="dataSharingAcceptanceYes" class="form-check-label">Oui</label>
                                </div>
                              </div>
                              <div class="col-4 col-lg-2">
                                <div class="form-check form-check-inline">
                                  <input id="dataSharingAcceptanceNo" type="radio" class="form-check-input" formControlName="dataSharingAcceptance" [value]="false" />
                                  <label for="dataSharingAcceptanceNo" class="form-check-label">Non</label>
                                </div>
                              </div>
                              <div class="col-2 col-lg-8">
                                <div class="form-check form-check-inline">
                                  <input id="dataSharingAcceptanceNoAnswer" type="radio" class="form-check-input" formControlName="dataSharingAcceptance" [value]="null" />
                                  <label for="dataSharingAcceptanceNoAnswer" class="form-check-label">Pas de réponse</label>
                                </div>
                              </div>
                            </div>
                            <!-- ********************************************************************************************* -->
                            <!-- Support choice explanation -->
                            <div class="row mt-4">
                              <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                                <label>
                                  Expliquez en quelques lignes (ou mots clés) les points de diagnostic <br />
                                  de la situation du/de la bénéficiaire qui vous ont conduit à la proposition de parcours
                                </label>
                                <textarea formControlName="supportChoiceExplanation" type="text" class="form-control"></textarea>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                      <div ngbAccordionFooter>
                        <button class="btn btn-outline-secondary btn-sm" (click)="scroll(orientationAccordion)">Précédent</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * Validation -->
        <div class="ms-auto">
          @if (submitted && (assessmentForm.invalid || supportForm.invalid)) {
            <small class="form-text text-danger"> Le formulaire n'est pas correctement complété. </small>
          }
        </div>
        <div class="row mt-4"></div>
      </div>
      <!-- ********************************************************************************************* -->
      <!-- * ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS * -->
      <!-- * ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS * -->
      <!-- ********************************************************************************************* -->
      <div class="row px-3">
        @if (!assessment?.id) {
          <div class="col-6 col-md-9 col-lg-6 mb-2"></div>
        }
        @if (assessment?.id) {
          <div class="col-3 col-md-9 col-lg-3 mb-2"></div>
        }
        <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION', 'DIRECTION+', 'TERRITORY']">
          @if (assessment?.id) {
            <div ngbDropdown class="d-grid col-3 col-md-9 col-lg-3 mb-2">
              <button class="btn btn-primary" id="dropdownActions" type="button" ngbDropdownToggle>
                <fa-icon icon="toolbox"></fa-icon>
                <span class="mx-3">Actions</span>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownActions">
                <!-- ********************************************************************************************* -->
                <!-- * Get PDF document -->
                <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="generateDocument()">
                  <fa-icon icon="print"></fa-icon>
                  <span class="ms-3 d-none d-md-block">Générer</span>
                </button>
                <!-- ********************************************************************************************* -->
                <!-- * Duplicate -->
                <ng-container>
                  @if (assessment.status === 'Validé') {
                    <button type="button" class="btn btn-primary d-flex" (click)="duplicate()" ngbDropdownItem>
                      <fa-icon icon="clone"></fa-icon>
                      <span class="ms-3 d-none d-md-block">Dupliquer</span>
                    </button>
                  }
                </ng-container>
                <!-- ********************************************************************************************* -->
                <!-- * Delete -->
                @if (!assessment.generatedSurveyFse) {
                  <button *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+', 'TERRITORY']" type="button" class="btn btn-primary d-flex" (click)="delete()" ngbDropdownItem>
                    <fa-icon icon="trash"></fa-icon>
                    <span class="ms-3 d-none d-md-block">Supprimer</span>
                  </button>
                }
              </div>
            </div>
          }
        </ng-container>
        <!-- ********************************************************************************************* -->
        <!-- * Cancel -->
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>
        <!-- ********************************************************************************************* -->
        <!-- * Save -->
        <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION+']">
          <div ngbDropdown class="d-grid col-3 col-md-6 col-lg-3 mb-1">
            <button class="btn btn-primary" id="dropdownActions" type="button" ngbDropdownToggle>
              <fa-icon icon="save"></fa-icon>
              <span class="mx-3">Sauvegarder</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownActions">
              <button class="btn btn-primary d-flex" type="submit" ngbDropdownItem (click)="save()">
                <fa-icon icon="save"></fa-icon>
                <span class="ms-3 d-none d-md-block">Sauvegarder</span>
              </button>
              @if (!assessment.generatedSurveyFse) {
                <button type="button" class="btn btn-primary d-flex" (click)="save(ActionSave.openModalSurveyFse)" ngbDropdownItem>
                  <fa-icon icon="save"></fa-icon>
                  <span class="ms-3 d-none d-md-block">Sauvegarder et générer FSE</span>
                </button>
              }
              @if (!assessment.generatedContract) {
                <button type="button" class="btn btn-primary d-flex" (click)="save(ActionSave.openModalContractEngagement)" ngbDropdownItem>
                  <fa-icon icon="save"></fa-icon>
                  <span class="ms-3 d-none d-md-block">Sauvegarder et générer un contrat</span>
                </button>
              }
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  }
</div>
